import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#081833] text-[#F5EBD9] overflow-hidden border-t border-[#F5EBD9]/10"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16 pt-24 sm:pt-32 pb-12 relative">
        <div className="absolute inset-0 sunset-glow opacity-60 pointer-events-none" />
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
          className="grid grid-cols-12 gap-8 mb-20 relative"
        >
          <div className="col-span-12 lg:col-span-8">
            <div className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#F5EBD9]/50 mb-6">
              Финална покана
            </div>
            <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-8xl leading-[0.95]">
              Разпродадено. <br />
              <span className="text-[#E0B95C]">На 25.10 — нещо специално.</span>
            </h2>
            <button
              onClick={() => scrollTo("notify")}
              data-testid="footer-cta"
              className="mt-10 inline-flex items-center gap-3 bg-[#E0B95C] text-[#0B1F3D] px-8 py-4 rounded-full uppercase tracking-widest text-sm font-bold hover:bg-[#F5EBD9] transition-all duration-300"
            >
              Запиши имейла си
              <ArrowUpRight className="w-4 h-4" strokeWidth={2.5} />
            </button>
          </div>
          <div className="col-span-12 lg:col-span-4 flex flex-col justify-end">
            <div className="space-y-6 font-mono text-xs uppercase tracking-[0.28em] text-[#F5EBD9]/75">
              <div>
                <div className="text-[#F5EBD9]/40 mb-1">Локация</div>
                <div>Хотел Черно Море · Варна</div>
              </div>
              <div>
                <div className="text-[#F5EBD9]/40 mb-1">Дата</div>
                <div>24 октомври 2026</div>
              </div>
              <div>
                <div className="text-[#F5EBD9]/40 mb-1">Организатор</div>
                <div>Иво Димовски</div>
              </div>
              <div>
                <div className="text-[#F5EBD9]/40 mb-1">Главен партньор</div>
                <div>КСБ · Варна</div>
              </div>
              <div>
                <div className="text-[#F5EBD9]/40 mb-1">Награда</div>
                <div>Златен Отвес 2026</div>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="border-t border-[#F5EBD9]/15 pt-8 flex flex-wrap items-center justify-between gap-4 text-xs font-mono uppercase tracking-[0.28em] text-[#F5EBD9]/50 relative">
          <div>© 2026 dimovsky.bg · Играта на Имотите</div>
          <div className="flex gap-6">
            <a href="mailto:hello@dimovsky.bg" className="hover:text-[#F5892E] transition-colors">
              hello@dimovsky.bg
            </a>
            <a href="https://dimovsky.bg" className="hover:text-[#F5892E] transition-colors">
              dimovsky.bg
            </a>
          </div>
        </div>
      </div>

      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-10 sm:-bottom-16 lg:-bottom-24 left-0 right-0 text-center font-serif text-[24vw] leading-none text-[#F5EBD9]/[0.04] select-none"
      >
        Варна
      </div>
    </footer>
  );
}
